<template>
  <div>
    <!-- ************************************************ Sensor setting -->
    <!-- <CForm class="needs-validationFda" novalidate>
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showSensor = showSensor === 1 ? false : 1"
          >
            <h5 class="text-primary">
              تنظیمات سنسور
              <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ sensor.updateTime }}</small
              >
            </h5>
          </CButton>
          <CCollapse :show="showSensor === 1">
            <CCardBody>
              <CRow>
                <CInput
                  maxLength="15"
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="دمای کمینه"
                  v-model="sensor.tempMin"
                  :value="sensor.tempMin"
                  required
                  type="number"
                />
                <CInput
                  maxLength="15"
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="دمای بیشینه"
                  v-model="sensor.tempMax"
                  :value="sensor.tempMax"
                  required
                  type="number"
                />
                <CInput
                  maxLength="15"
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="رطوبت کمینه"
                  v-model="sensor.humMin"
                  :value="sensor.humMin"
                  required
                  type="number"
                />
                <CInput
                  maxLength="15"
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="رطوبت بیشینه"
                  v-model="sensor.humMax"
                  :value="sensor.humMax"
                  required
                  type="number"
                />
                <CInput
                  placeholder="دقیقه"
                  class="col-sm-12 col-md-6 col-lg-4"
                  label="دوره آلارم"
                  v-model="sensor.alarmPeriod"
                  :value="sensor.alarmPeriod"
                  required
                  type="number"
                />
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="recieveDeviceSetting('sensor')"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setDeviceSetting('sensor')"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
               
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm> -->

    <!-- *********************************************** alarm Setting -->
    <CForm class="needs-validationWebAlarm" novalidate>
      <CRow class="mt-2">
        <CCard class="mb-0 p-0">
          <CButton
            block
            class="text-right shadow-none card-header"
            @click="showAlarm = showAlarm === 7 ? false : 7"
          >
            <h5 class="text-primary">
              آلارم سنسور- وب
              <!-- <small class="text-secondary mx-3"
                >آخرین به روزرسانی: {{ alarmUpdateTime }}</small
              > -->
            </h5>
          </CButton>
          <CCollapse :show="showAlarm === 7">
            <CCardBody>
              <CRow class="mt-2 p-2">
                <table class="table table-striped m-2">
                  <thead>
                    <tr>
                      <th scope="col">ردیف</th>
                      <th scope="col">سنسور</th>
                      <th scope="col">بیشینه</th>
                      <th scope="col">کمینه</th>
                      <th scope="col">دوره آلارم</th>
                      <th scope="col">کالیبراسیون</th>
                      <th scope="col">فعال بودن آلارم</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in alarmMinMax" :key="i">
                      <!-- <th scope="row">{{i+1}}</th> -->
                      <td>{{ i + 1 }}</td>
                      <td>{{ item.sensorName }}</td>
                      <td>
                        <CInput
                          type="number"
                          required
                          v-model="item.alarmMax"
                          :value="item.alarmMax"
                        />
                      </td>

                      <td>
                        <CInput
                          type="number"
                          required
                          v-model="item.alarmMin"
                          :value="item.alarmMin"
                        />
                      </td>
                      <td>
                        <CInput
                          type="number"
                          required
                          v-model="item.alarmTime"
                          :value="item.alarmTime"
                        />
                      </td>
                      <td>
                        <CInput
                          type="number"
                          required
                          v-model="item.calibration"
                          :value="item.calibration"
                        />
                      </td>
                      <td>
                        <CInputCheckbox
                          :checked="item.alarmActive"
                          @change="item.alarmActive = !item.alarmActive"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CRow>
              <CRow class="justify-content-center mt-2">
                <CButton
                  @click="getSensors(deviceId)"
                  color="info"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon
                    name="cil-cloud-download"
                    class="mx-1"
                  />دریافت</CButton
                >
                <CButton
                  @click="setSensors()"
                  color="success"
                  class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                  ><CIcon name="cil-check-circle" class="mx-1" />اعمال</CButton
                >
                <!-- <CButton
                    @click="refreshDeviceSetting('sensor')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
              </CRow>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CRow>
    </CForm>
  </div>
</template>

<script>
import axios from "axios";
import { Values } from "../../../src/commonValues";
import $ from "jquery";

export default {
  props: ["deviceId"],
  data() {
    return {
      sensor: {
        tempMin: "",
        tempMax: "",
        humMin: "",
        humMax: "",
        alarmPeriod: "",
        updateTime: "",
      },

      alarmMinMax: [],
      alarmUpdateTime: "",

      showSensor: 1,
      showAlarm: 1,
      alert: false,
      alertText: "",
      ipformat:
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      mobileFormat: /^(09(0[1-2]|1[0-9]|3[0-9]|2[0-1])-?[0-9]{3}-?[0-9]{4})$/,
      emailFormat: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    };
  },

  mounted() {
    // for (let i=0;i<=1; i++){this.alarmMinMax.push({
    //   deviceId: this.deviceId,
    //   sensorType: "1",
    //   sensorIndex: "2",
    //   alarmTime: "25",
    //   alarmMin: "36",
    //   alarmMax: "40",
    // });}
  },

  methods: {
    //********************************************************************* recieve sensor data */
    getSensors(data) {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(Values.serverIp + "Sensor/GetSensorsAlarmWebUi", data, config)
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.alarmMinMax = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //********************************************************************* recieve sensor data */
    setSensors() {
      var forms = document.querySelectorAll(".needs-validationWebAlarm");
      let formValid = true;

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "select-one" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "text" &&
          !forms[0][i].value.match(this.ipformat) &&
          !forms[0][i].value.length == 0 &&
          forms[0][i].maxLength == 15
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        }
      }
      if (formValid == true) {
        const config = { headers: { "Content-Type": "application/json" } };
        for (var i = 0; i < this.alarmMinMax.length; i++) {
          if (this.alarmMinMax[i].alarmMax == "")
            this.alarmMinMax[i].alarmMax = null;
          if (this.alarmMinMax[i].alarmMin == "")
            this.alarmMinMax[i].alarmMin = null;
          if (this.alarmMinMax[i].alarmTime == "")
            this.alarmMinMax[i].alarmTime = 0;
          if (this.alarmMinMax[i].calibration == "")
            this.alarmMinMax[i].calibration = 0;
        }
        axios
          .post(
            Values.serverIp + "Sensor/UpdateSensorsAlarmWeb",
            this.alarmMinMax,
            config
          )
          .then((response) => {
            if (response.status == 200) {
              console.log(response.data);
              if (response.data == 0) {
                this.$emit("update", 1);
              } else {
                this.$emit("update", 2);
              }
            }
          })
          .catch((response) => {
            if (response.status != 200) {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
              (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            }
          });
      } else {
        this.alert = true;
        this.alertText = "لطفا تمامی موارد الزامی را وارد نمایید.";
      }
    },
    //   *********************************************************************set Device Setting
    setDeviceSetting(data) {
      var forms = document.querySelectorAll(".needs-validationFda");
      let formValid = true;

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "text" &&
          !forms[0][i].value.match(this.ipformat) &&
          !forms[0][i].value.length == 0 &&
          forms[0][i].maxLength == 15
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "select-one" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        }
      }
      // if (this.info.status.value == "") {
      //   $(".needs-validation > .multiselect__tags").css(
      //     "border-color",
      //     "red"
      //   );
      //   formValid = false;
      // }

      if (!formValid) {
        // console.log("bad ip");
        this.alert = true;
        this.alertText = "داده های وارد شده صحیح نمی باشد.";
      } else {
        axios
          .post(Values.serverIp + "FDADeviceSetting/SetSensorsSetting", {
            deviceId: this.deviceId,
            // sensor
            sensorIndex: 1,
            sensorTypeRegister: 0,
            sensorEnable: false,
            sensorValuesList: [
              {
                sensorType: 1,
                validHighLimit: 0,
                validLowLimit: 0,
                alarmHighLimit: this.sensor.tempMax,
                alarmLowLimit: this.sensor.tempMin,
                calibration: 0,
              },
              {
                sensorType: 2,
                validHighLimit: 0,
                validLowLimit: 0,
                alarmHighLimit: this.sensor.humMax,
                alarmLowLimit: this.sensor.humMin,
                calibration: 0,
              },
            ],
          })
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              if (response.data == 1) {
                this.$emit("update", 1);
              } else if (response.data == 2) {
                this.alert = true;
                this.alertText = "خطا!!! لطفا دوباره تلاش فرمایید.";
              }
              // modal successfuly
            } else {
              // modal unsuccessful edit change
              this.$emit("update", 2);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //******************************************************************recieve Device Setting  */
    recieveDeviceSetting(data) {
      console.log("receive");
      axios
        .post(Values.serverIp + "FDADeviceSetting/GetSensorsSetting", {
          deviceId: this.deviceId,
          // sensor
          sensorIndex: 1,
          sensorTypeRegister: 0,
          sensorEnable: false,
          sensorValuesList: [],
        })
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);

            this.setValues(response.data);

            // modal successfuly
          } else {
            // modal unsuccessful edit change
            this.$emit("update", 2);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // *****************************************************************restore Default
    restoreDefault() {
      console.log(this.deviceId);

      // make all part to enabled
      $(".form-check, .form-control-file, .form-control").attr(
        "disabled",
        false
      );

      // clear all red borders
      $(".form-control, .needs-validationFda > .multiselect__tags").removeAttr(
        "style"
      );

      this.sensor.tempMin = "";
      this.sensor.tempMax = "";
      this.sensor.humMin = "";
      this.sensor.humMax = "";
      this.sensor.updateTime = "";
      this.sensor.alarmPeriod = "";

      //this.alarmMinMax=[];
    },

    //******************************************************************* set values */
    setValues(data) {
      this.sensor.updateTime = data.sensorInformationLastUpdateDateTimeJalali;

      for (let i = 0; i < data.sensorValuesList.length; i++) {
        if (data.sensorValuesList[i].sensorType == 1) {
          this.sensor.tempMin = data.sensorValuesList[i].alarmLowLimit;
          this.sensor.tempMax = data.sensorValuesList[i].alarmHighLimit;
        } else if (data.sensorValuesList[i].sensorType == 2) {
          this.sensor.humMin = data.sensorValuesList[i].alarmLowLimit;
          this.sensor.humMax = data.sensorValuesList[i].alarmHighLimit;
        }
      }
    },
  },
};
</script>

<style>
</style>